import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { fetchVerifyFadvCsvMetadata } from "model/CandidateModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const VerifyFadvCsvContext = createContext();

export const VerifyFadvCsvProvider = ({ children }) => {
    const { fetchMetadataSchema } = useCommonFilterOptions();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [verifyFadvCsvContextData, setVerifyFadvCsvContextData] = useState();

    const fetchVerifyFadvCsvContextData = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetchMetadataSchema("metadata:verifyFadvCsv", () =>
                fetchVerifyFadvCsvMetadata([])
            );
            if (response?.success) {
                setVerifyFadvCsvContextData(response?.data);
            } else {
                setError(response?.message || "Unable to fetch verify FADV CSV metadata");
            }
        } catch (err) {
            toast.error(err?.message || "Something went wrong");
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <VerifyFadvCsvContext.Provider
            value={{
                fetchVerifyFadvCsvContextData,
                verifyFadvCsvContextData,
                loading,
                error,
            }}
        >
            {children}
        </VerifyFadvCsvContext.Provider>
    );
};

export const useVerifyFadvCsvContext = () => useContext(VerifyFadvCsvContext);
